import { useQuery } from "react-query";
import { axiosClient } from "../services/axiosInstance";

const useGetHobbies = () => {
  const data = useQuery(["gethobbies"], () =>
    axiosClient.post(`Setting/GepSettingList?groupSettingId=22`)
  );
  return data;
};
export default useGetHobbies;
